(function ($) {
    "use strict";

    function Toggler(element, config) {
        var self = this;

        this.id = this.generateGuid();
        this.element = $(element).attr('id', this.id);

        this.config = $.extend({}, this.__defaultConfig, config || {});
        this.config.toggleClass = this.element.data('toggle-class') || this.config.toggleClass;
        this.config.toggleSelector = this.element.data('toggle-selector') || this.config.toggleSelector;

        this.element.find(this.config.toggleSelector).click(function (e) {
            self.toggle();
            $(document).trigger('click', e);
            return false;
        });

        if (!this.config.disableOnDocumentClickHiding) {
            $(document).on('click', function (e, customEvent) {
                self.handleDocumentClick(customEvent || e);
            });
        }

        if (!this.config.disableOnScrollHiding) {
            $(window).on('scroll', function (e) {
                self.handleDocumentClick(e);
            });
        }
    }

    Toggler.prototype.__defaultConfig = {
        toggleSelector: '.toggle',
        toggleClass: 'active',
        onShow: null,
        onHide: null,
        disableOnScrollHiding: false,
        disableOnDocumentClickHiding: false
    };

    Toggler.prototype.toggle = function () {
        var action = this.element.hasClass(this.config.toggleClass) ? 'hide' : 'show';
        this[action]();
    };

    Toggler.prototype.hide = function () {
        this.element.removeClass(this.config.toggleClass);

        if (this.config.onHide instanceof Function) {
            this.config.onHide(this);
        }
    };

    Toggler.prototype.show = function () {
        this.element.addClass(this.config.toggleClass);

        if (this.config.onShow instanceof Function) {
            this.config.onShow(this);
        }
    };

    Toggler.prototype.generateGuid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return 'tgl' + s4() + s4();
    };

    Toggler.prototype.handleDocumentClick = function (e) {
        var target = $(e.target);
        var id = '#' + this.id;
        var innerObject = target.parents(id).length > 0;
        var isObject = target.is(id);

        if (!innerObject && !isObject) {
            this.hide();
        }
    };

    $.fn.Toggler = function (options) {
        this.each(function () {
            new Toggler(this, options);
        });
    };
})(jQuery);
